import createIcon from '../../createIcon';

/**
 * @component @name VolunteerActivism
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNS40OTUxMiAxMUgxLjQ5NTEyVjIySDUuNDk1MTJWMTFaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTYuNDk1MSAzLjI1QzE3LjE0NTEgMi40OSAxOC4xNTUxIDIgMTkuMTk1MSAyQzIxLjA0NTEgMiAyMi40OTUxIDMuNDUgMjIuNDk1MSA1LjNDMjIuNDk1MSA3LjU3IDE5LjU4NTEgMTAuMiAxNi40OTUxIDEzQzEzLjQwNTEgMTAuMTkgMTAuNDk1MSA3LjU2IDEwLjQ5NTEgNS4zQzEwLjQ5NTEgMy40NSAxMS45NDUxIDIgMTMuNzk1MSAyQzE0LjgzNTEgMiAxNS44NDUxIDIuNDkgMTYuNDk1MSAzLjI1WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTIwLjQ5NTEgMTdIMTMuNDk1MUwxMS40MDUxIDE2LjI3TDExLjczNTEgMTUuMzNMMTMuNDk1MSAxNkgxNi4zMTUxQzE2Ljk2NTEgMTYgMTcuNDk1MSAxNS40NyAxNy40OTUxIDE0LjgyQzE3LjQ5NTEgMTQuMzMgMTcuMTg1MSAxMy44OSAxNi43MjUxIDEzLjcxTDkuNDY1MTIgMTFINy40OTUxMlYyMC4wMkwxNC40OTUxIDIyTDIyLjUwNTEgMTlDMjIuNDk1MSAxNy45IDIxLjYwNTEgMTcgMjAuNDk1MSAxN1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const VolunteerActivism = createIcon('VolunteerActivism', [
  ['path', { d: 'M5.49512 11H1.49512V22H5.49512V11Z', key: '177xho' }],
  [
    'path',
    {
      d: 'M16.4951 3.25C17.1451 2.49 18.1551 2 19.1951 2C21.0451 2 22.4951 3.45 22.4951 5.3C22.4951 7.57 19.5851 10.2 16.4951 13C13.4051 10.19 10.4951 7.56 10.4951 5.3C10.4951 3.45 11.9451 2 13.7951 2C14.8351 2 15.8451 2.49 16.4951 3.25Z',
      key: '14i21l',
    },
  ],
  [
    'path',
    {
      d: 'M20.4951 17H13.4951L11.4051 16.27L11.7351 15.33L13.4951 16H16.3151C16.9651 16 17.4951 15.47 17.4951 14.82C17.4951 14.33 17.1851 13.89 16.7251 13.71L9.46512 11H7.49512V20.02L14.4951 22L22.5051 19C22.4951 17.9 21.6051 17 20.4951 17Z',
      key: 'yhnct4',
    },
  ],
]);

export default VolunteerActivism;
